import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchPhotoSessionView = async ({ patientId, sessionId }) => {
  const token = localStorage.getItem("token");

  const response = await axios.get(
    `${__API_URL__}/api/patient/patient/photo_session_view/?PatientId=${patientId}&sessionId=${sessionId}`,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return response.data;
};

const useGetPhotoSessionView = ({ patientId, sessionId, enabled = true }) => {
  return useQuery({
    queryKey: ["photo_session_view", patientId, sessionId],
    queryFn: () => fetchPhotoSessionView({ patientId, sessionId }),
    enabled: enabled && Boolean(patientId) && Boolean(sessionId),
  });
};

export default useGetPhotoSessionView;
